import { useQuery } from '@tanstack/react-query'
import { useApiClientAmbassador } from '~/@api/client/useApiClientAmbassador'

/**
 * Public lookup of an ambassador by referral code (no auth required).
 * Used to render the ambassador preview on the register page.
 */
export function usePublicAmbassadorInfo(code: string | undefined) {
  const api = useApiClientAmbassador()

  return useQuery({
    queryKey: ['public-ambassador-info', code],
    enabled: code != null,
    retry: false,
    queryFn: async () => {
      const resp =
        await api.ambassador.publicAmbassadorControllerGetAmbassadorByCode(
          code!
        )
      return resp.data.data
    },
  })
}
